var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClock16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 2a5 5 0 1 0 0 10A5 5 0 0 0 8 3m0 1a1 1 0 0 1 1 1v2h1a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"
})));
export default SvgIcClock16;